const releasesEN = {
    "view": {
        "table": {
            "title": "Your releases list",
            "column": {
              "name": "Name",
              "artist": "Artist",
              "catalogue_number": "Cat. No.",
              "release_date": "Release Date",
              "status": "Status",
              "store_urls": "Store Urls",
              "qc": "QC",
              "pre_scan": "Pre Scan",
              "alert": "Alert",
              "flagged": "Flagged",
              "action": "Action"
            },
            "label": {
              "status_ready": "Ready",
              "status_approval": "Submission Queued",
              "status_takedown_request": "Takedown request",
              "status_taken_down": "Taken down",
              "status_distributed": "Distributed",
              "status_locked": "In Progress - Locked",
              "status_delivering": "Delivering",
              "status_unlocked": "Please Edit",
              "status_offline": "Offline",
              "status_re_delivery-delivery": "Re-delivery",
              "status_re_delivery-editing": "Re-delivery Editing",
              "status_unknown": "Unknown Status"
            },
            "button": {
              "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "dropdown": {
              "item": {
                "action": "Action",
                "distribute": "Distribute",
                "viewRelease": "View Release",
                "editReleaseMetadata": "Edit Release Metadata",
                "editTracks": "Edit Tracks",
                "takedown": "Takedown",
                "submitEditing": "Submit Editing",
                "deliveredList": "Delivered List",
                "copyEanUpc": "Copy EAN/UPC",
              },
              "message": {
                "submitInformationTooltip": "You have not yet provided your complete information, therefore you can't distribute the releases. In order to do so kindly Submit Your Information.",
                "submitMetadataTooltip": "Please submit the metadata for all Tracks in order to Distribute the Release.",
                "submitEditingMetadataTooltip": "Please submit the metadata for all tracks, in order to Submit the Edits.",
                "submitEditingTokenRequiredTooltip": "At least 1 token is required to submit editing for re-delivery. <2>Order tokens</2>.",
                "blacklistedArtistTooltip": "This release cannot be distributed as it contains one or more tracks from a blacklisted artist. Please contact our support team for further information.",
                "distributionDisabledPreScanInProgress": "Please wait for the pre scan to complete first in order to distribute the release.",
                "distributionDisabledPreScanNotDone": "Please perform pre scan first in order to distribute the release.",
                "distributionDisabledPreScanDeclarationNotSubmitted": "Please submit the pre-scan declaration first in order to distribute the release.",
              },
              "modal": {
                "editMetadata": {
                  "header": "Are you really sure that you want to edit the metadata?",
                  "description": {
                    "point1": "<strong>This will change your metadata and can affect the release.</strong>",
                    "point2": "Proceed only if you are completely sure.",
                    "point3": "<strong>PLEASE DO NOT</strong> edit metadata just for testing and exploring."
                  },
                  "button": {
                    "cancel": "Cancel",
                    "confirm": "I understand"
                  }
                },
                "distribute": {
                  "header": "Are you sure all information entered is valid and represents this release fully?",
                  "description": {
                    "point1": "After this action, your release will be checked and if the information is correct it will be distributed on the official and exclusive distribution dates.",
                    "point2": "By confirming and accepting this form, you are fully accepting and complying with the <1>Terms Of Distribution</1>, <3>Terms Of Use</3> and <5>Privacy Policy</5>.",
                    "point3": "By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.",
                    "point4": "Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.",
                    "flaggedTracksTerms": {
                      "header": "Flagged Tracks Terms",
                      "point1": "Please note: <strong>'{{releaseName}}'</strong> contains one or more flagged tracks, A fee of <strong>15 €</strong> per flagged track applies in order to deliver the release to <strong>Spotify</strong>. As you have opted not to pay this fee at this time, the release will not be delivered to Spotify. By confirming and accepting this form, you acknowledge and accept these terms.",
                      "point2": "In future if you opt for the release to be delivered to <strong>Spotify</strong> you can go to the Flagged section in Releases table and follow the payment prompts.",
                    },
                    "artificialStreamingDeclaration": {
                      "header": "Artificial Streaming Declaration",
                      "point1": "<strong>1.</strong> I fully understand and agree not to engage in any form of artificial streaming, including the use of bots, streaming farms, or any method that manipulates DSP metrics.",
                      "point2": "<strong>2.</strong> I will not pay or offer payment for playlist placements, nor will I work with any third party promising guaranteed placements — I understand this is considered fraud and a scam.",
                      "point3": "<strong>3.</strong> I acknowledge that any such actions may result in immediate termination, forfeiture of royalties, legal claims, contractual penalties and fees, and reporting to DSPs and authorities.",
                      "point4": "<strong>4.</strong> I also guarantee to inform and educate any artists or clients I work with about these rules and ensure they comply.",
                      "point5": "<strong>5.</strong> I understand that if I engage in artificial streaming, my KYC data, including my full name, address, ID card, and other personal information, can be shared with the DSP's legal departments, such as those of Spotify, Apple Music, and others.",
                      "point6": "<strong>6.</strong> I accept full legal responsibility for any violations.",
                      "acknowledgment": "I hereby acknowledge and agree to abide by the above Artificial Streaming terms, and I accept full legal responsibility for any violations.",
                    },
                  },
                  "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm and Accept"
                  }
                },
                "takedown": {
                  "header": "Are you sure you want to remove this release from all stores?",
                  "description": {
                    "point1": "This action is irreversible.",
                    "point2": "By taking this release down, you are complying with the <1>Terms Of Distribution</1>, <3>Terms Of Use</3> and <5>Privacy Policy</5>.",
                  },
                  "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm and Accept"
                  }
                },
                "finishEditing": {
                  "header": "Are you sure all information entered is valid and represents this release fully?",
                  "description": {
                    "point1": "After this action, your release will be checked and if the information is correct it will be re-distributed to the DSP partners. <strong>NOTE, only METADATA will be sent to DSP-s, content such as IMAGE and AUDIO files can not be updated this way.</strong>",
                    "point2": "By confirming and accepting this form, you are fully accepting and complying with the <1>Terms Of Use</1> and Terms of our Exclusive Distribution Agreement.",
                    "point3": "By confirming and accepting this form, you are fully accepting and complying with the <1>Privacy Policy</1>.",
                    "point4": "By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.",
                    "point5": "Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.",
                  },
                  "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm and Accept"
                  }
                }
              }
            },
            "message": {
              "success": "Release updated!",
              "declaration_success": "Declaration submitted for admin review.",
              "declaration_error": "Something went wrong while submitting declaration, please try again later.",
              "pre_scan_declaration_success": "Pre Scan declaration submitted successfully.",
              "pre_scan_declaration_error": "Something went wrong while submitting pre scan declaration, please try again later.",
              "pre_scan_success": "Release successfully submitted for scan.",
              "pre_scan_error": "Something went wrong while scanning the release, please try again later.",
              "linkCopied": "Link copied to clipboard!"
            }
        },
        "message": {
          "trackDistributionAllowanceSpent": "You have spent your track distribution allowance. In order to upload more tracks please upgrade your account or contact our support team.",
          "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
          "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
          "noAccess": "You don't have access to this module, please contact the support team for further information.",
          "subscriptionUpgradeReleaseTransfer": "Your current subscription plan does not support release transfer feature. If you are transferring a bigger back catalog or wish to transfer more record labels catalogs to Music Link with just a few clicks, please <1>upgrade</1> your subscription plan.",
          "noAccessReleaseTransfer": "Currently, you do not have permission to use release transfer feature. If you are transferring a bigger back catalog or wish to transfer more record labels catalogs to Music Link with just a few clicks, don't hesitate to contact our support team.",
          "accountBlacklisted": "Your account has been blacklisted after review as we have found that the information associated with your account is linked with one of the internationally blacklisted users in our system. Consequently, we have disabled the Distribution feature for your account.",
        }
    },
    "add": {
        "title": "Add New Release",
        "form": {
            "label": {
                "required": "Required",
                "name": "Release Name",
                "version": "Release Version",
                "subuser": "Sub-User",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Year",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Year",
                "genre": "Genre",
                "subgenre": "Sub-Genre",
                "catalog_number": "Catalog Number",
                "artwork": "Artwork",
                "artwork_alt": "Your artwork",
                "new_release": "Is This A New Release?",
                "original_release_date": "Original release date",
                "official_release_date": "Official release date",
                "backcatalog": "Backcatalog",
                "assisted_dates": "Assisted Dates",
                "exclusive_store_release_date": "Exclusive store release date",
                "additional_metadata": "Additional Metadata",
                "release_description": "Release Description",
                "release_language": "Release Name Language",
                "auto_detect_language": "Auto Detect (Language)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Auto generate (ean)",
                "territories": "Territories",
                "countries": "Countries",
                "youtube_declaration_header": "YOUTUBE CONTENT ID DECLARATION",
                "youtube_declaration_intro": "To opt-in for YouTube Content ID for this release, you must ensure you meet ALL the following requirements:",
                "youtube_declaration_certify": "I, <strong>{{firstName}} {{lastName}}</strong>, under penalty of perjury, hereby certify that the foregoing information is true and correct.",
                "youtube_declaration_point1": "I have sufficient rights to the material.",
                "youtube_declaration_point2": "All reference content is sufficiently distinctive.",
                "youtube_declaration_point3": "I have individual references for each piece of intellectual property.",
                "youtube_declaration_point4": "Content delivered is <strong>not</strong> any of the following: public domain, non-exclusively licensed content, clips from other sources used under fair use principles, video gameplay footage (by other than the game’s publisher), karaoke recordings, remaster without permission, sound-alike recordings, dubbed content, speedup/slowdown, sound effects, soundbeds, continuous DJ mixes, mashups, countdown lists or any other prohibited or ineligible content named in the YouTube’s Content ID Guidelines listed below.",
                "youtube_declaration_account": "I understand that my account may be deactivated and terminated in case of any violations. Furthermore, I fully understand that I may be liable for any fees, damages, legal expenses, or any other expenses that may accrue.",
                "youtube_declaration_guidelines": "According to <1><strong>YouTube's Content ID Guidelines</strong></1>, content submitted through this release is fully eligible for YouTube Content ID.",
                "youtube_content_id_eligible": "I confirm that my content is eligible for <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "My content is not eligible for <strong>Youtube Content ID</strong>",
                "immersive_audio": "This Release has Immersive Audio"
            },
            "placeholder": {
                "version": "Leave blank if you are not sure or if this is a regular release",
                "select_date": "Select date...",
                "copyright": "Usually your label name",
                "copyright_publisher": "Usually your label name",
                "copyright_year": "YYYY",
                "copyright_year_publisher": "YYYY",
                "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
                "label": "Select Label...",
                "subuser": "Select Sub-user...",
                "genre": "Select Genre...",
                "subgenre": "Select Sub-Genre...",
                "ean": "Leave blank if you are not sure!",
                "release_description": "A few words about your release. No links and e-mail addresses please. 600 characters max"
            },
            "help_text": {
                "name": "Please do not use release name additions such as LP and EP.",
                "version": "Some releases are released in more than one version, if so please enter the version name. If your release is original/standard release please ignore this field.",
                "subuser": "Note: Only use this dropdown if you want to add a release for any of your Sub-users otherwise leave un-selected.",
                "label": "Note: Please select your Label from the dropdown if it already exists in system, otherwise create your Label by clicking <1>here</1>, once it is created you can then select it from dropdown.",
                "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
                "artwork": "Upload JPG formats, resolution only 3000x3000 px, @ 72 dpi",
                "original_release_date": "Original release date for all shops worldwide.",
                "official_release_date": "Official release date for all shops worldwide.",
                "release_language": "In which language is the release name written? Please double check it if you are not sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
                "ean": "The Universal Product Code or European Article Number for the release. Valid codes are 13 digits. If you don't have your own, we will generate one for you.",
            },
            "option": {
                "yes": "Yes",
                "no": "No",
                "no_exclusive": "No exclusive",
                "beatport_2weeks": "Beatport 2 weeks",
                "beatport_4weeks": "Beatport 4 weeks",
                "preorder_1week": "Pre-order 1 week",
                "preorder_2weeks": "Pre-order 2 weeks",
                "traxsource_2weeks": "Traxsource 2 weeks",
                "select": "Select...",
                "worldwide": "Worldwide",
                "only_selected": "Only selected countries",
                "all_except_selected": "All except selected countries"
            },
            "message": {
                "track_name_required": "Please type track name",
                "mix_name_required": "Please type mix name",
                "mix_name_invalid": "The mix name can only consist of alphabetical, number, space and underscore",
                "artist_required": "Please select artist",
                "artist_type_required": "Please select artist type",
                "catalog_duplicate": "Catalog number '{{number}}' was used. Please insert another one.",
                "ean_duplicate": "This EAN Number is associated with another release. Please insert another one.",
                "artist_added": "New Artist has been added!",
                "track_limit": "Your current track limit is insufficient. Please upgrade your account or contact support.",
                "select_day": "Please select a day.",
                "form_error": "Form cannot be submitted! Please fill all fields and check errors!",
                "ean_invalid": "The value is not valid EAN. If you are inserting a new release, leave this field blank and we will generate EAN for you. If you are uploading a back catalog and EAN is not valid, please contact us.",
                "ean_length": "The EAN number must be equal to 13 characters",
                "artwork_invalid": "This file is invalid, please make sure the image has .jpg extension, RGB Colours, 3000 X 3000 dimensions and up to 4MB.",
                "track_invalid": "This file is invalid, please make sure to properly encode your file in 16 bit, 44.1 Khz.",
            },
            "button": {
                "reset": "Reset",
                "save_only": "Save only",
                "save_and_continue": "Save and continue"
            },
            "modal": {
                "assisted_days": {
                    "header": "Are you sure you want to ignore release date best practices?",
                    "body": "Please note by selecting this option, your release date might not be accepted by stores or ingested and published on the selected date. Additionally, you are strongly reducing the marketing opportunities.",
                    "button": {
                        "cancel": "Cancel",
                        "confirm": "Confirm"
                    }
                },
                "release_created": {
                    "header": "Release created!",
                    "body": "Your release was successfully created!",
                    "button": {
                        "close": "Close"
                    }
                }
            }
        },
    },
    "update": {
        "title": "Update Release",
        "form": {
          "label": {
              "required": "Required",
              "name": "Release Name",
              "version": "Release Version",
              "subuser": "Sub-User",
              "label": "Label",
              "copyright": "Copyright ©",
              "copyright_year": "Copyright © Year",
              "copyright_publisher": "Copyright ℗",
              "copyright_publisher_year": "Copyright ℗ Year",
              "genre": "Genre",
              "subgenre": "Sub-Genre",
              "catalog_number": "Catalog Number",
              "artwork": "Artwork",
              "artwork_alt": "Your artwork",
              "new_release": "Is This A New Release?",
              "original_release_date": "Original release date",
              "official_release_date": "Official release date",
              "backcatalog": "Backcatalog",
              "assisted_dates": "Assisted Dates",
              "exclusive_store_release_date": "Exclusive store release date",
              "additional_metadata": "Additional Metadata",
              "release_description": "Release Description",
              "release_language": "Release Name Language",
              "auto_detect_language": "Auto Detect (Language)",
              "ean": "EAN / UPC",
              "auto_generate_ean": "Auto generate (ean)",
              "territories": "Territories",
              "countries": "Countries",
              "youtube_declaration_header": "YOUTUBE CONTENT ID DECLARATION",
              "youtube_declaration_intro": "To opt-in for YouTube Content ID for this release, you must ensure you meet ALL the following requirements:",
              "youtube_declaration_certify": "I, <strong>{{firstName}} {{lastName}}</strong>, under penalty of perjury, hereby certify that the foregoing information is true and correct.",
              "youtube_declaration_point1": "I have sufficient rights to the material.",
              "youtube_declaration_point2": "All reference content is sufficiently distinctive.",
              "youtube_declaration_point3": "I have individual references for each piece of intellectual property.",
              "youtube_declaration_point4": "Content delivered is <strong>not</strong> any of the following: public domain, non-exclusively licensed content, clips from other sources used under fair use principles, video gameplay footage (by other than the game’s publisher), karaoke recordings, remaster without permission, sound-alike recordings, dubbed content, speedup/slowdown, sound effects, soundbeds, continuous DJ mixes, mashups, countdown lists or any other prohibited or ineligible content named in the YouTube’s Content ID Guidelines listed below.",
              "youtube_declaration_account": "I understand that my account may be deactivated and terminated in case of any violations. Furthermore, I fully understand that I may be liable for any fees, damages, legal expenses, or any other expenses that may accrue.",
              "youtube_declaration_guidelines": "According to <1><strong>YouTube's Content ID Guidelines</strong></1>, content submitted through this release is fully eligible for YouTube Content ID.",
              "youtube_content_id_eligible": "I confirm that my content is eligible for <strong>Youtube Content ID</strong>",
              "youtube_content_id_not_eligible": "My content is not eligible for <strong>Youtube Content ID</strong>",
              "immersive_audio": "This Release has Immersive Audio"
          },
          "placeholder": {
              "version": "Leave blank if you are not sure or if this is a regular release",
              "select_date": "Select date...",
              "copyright": "Usually your label name",
              "copyright_publisher": "Usually your label name",
              "copyright_year": "YYYY",
              "copyright_year_publisher": "YYYY",
              "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
              "label": "Select Label...",
              "subuser": "Select Sub-user...",
              "genre": "Select Genre...",
              "subgenre": "Select Sub-Genre...",
              "ean": "Leave blank if you are not sure!",
              "release_description": "A few words about your release. No links and e-mail addresses please. 600 characters max"
          },
          "help_text": {
              "name": "Please do not use release name additions such as LP and EP.",
              "version": "Some releases are released in more than one version, if so please enter the version name. If your release is original/standard release please ignore this field.",
              "subuser": "Note: Only use this dropdown if you want to add a release for any of your Sub-users otherwise leave un-selected.",
              "label": "Note: Please select your Label from the dropdown if it already exists in system, otherwise create your Label by clicking <1>here</1>, once it is created you can then select it from dropdown.",
              "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
              "artwork": "Upload JPG formats, resolution only 3000x3000 px, @ 72 dpi",
              "original_release_date": "Original release date for all shops worldwide.",
              "official_release_date": "Official release date for all shops worldwide.",
              "release_language": "In which language is the release name written? Please double check it if you are not sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
              "ean": "The Universal Product Code or European Article Number for the release. Valid codes are 13 digits. If you don't have your own, we will generate one for you.",
          },
          "option": {
              "yes": "Yes",
              "no": "No",
              "no_exclusive": "No exclusive",
              "beatport_2weeks": "Beatport 2 weeks",
              "beatport_4weeks": "Beatport 4 weeks",
              "preorder_1week": "Pre-order 1 week",
              "preorder_2weeks": "Pre-order 2 weeks",
              "traxsource_2weeks": "Traxsource 2 weeks",
              "select": "Select...",
              "worldwide": "Worldwide",
              "only_selected": "Only selected countries",
              "all_except_selected": "All except selected countries"
          },
          "message": {
              "track_name_required": "Please type track name",
              "mix_name_required": "Please type mix name",
              "mix_name_invalid": "The mix name can only consist of alphabetical, number, space and underscore",
              "artist_required": "Please select artist",
              "artist_type_required": "Please select artist type",
              "catalog_duplicate": "Catalog number '{{number}}' was used. Please insert another one.",
              "ean_duplicate": "This EAN Number is associated with another release. Please insert another one.",
              "artist_added": "New Artist has been added!",
              "track_limit": "Your current track limit is {{trackLimit}} track(s). In order to upload more tracks please upgrade your account or contact our support team.",
              "select_day": "Please select a day.",
              "form_error": "Form cannot be submitted! Please fill all fields and check errors!",
              "ean_invalid": "The value is not valid EAN. If you are inserting a new release, leave this field blank and we will generate EAN for you. If you are uploading a back catalog and EAN is not valid, please contact us.",
              "ean_length": "The EAN number must be equal to 13 characters",
              "artwork_invalid": "This file is invalid, please make sure the image has .jpg extension, RGB Colours, 3000 X 3000 dimensions and up to 4MB.",
              "track_invalid": "This file is invalid, please make sure to properly encode your file in 16 bit, 44.1 Khz.",
              "artworkSwapTokenRequiredTooltip": "Your current token balance is insufficient. At least 1 token is required to swap cover artwork.",
          },
          "button": {
              "reset": "Reset",
              "submit_form": "Submit Form",
              "save_and_continue": "Save and continue"
          },
          "modal": {
            "assisted_days": {
              "header": "Are you sure you want to ignore release date best practices?",
              "body": "Please note by selecting this option, your release date might not be accepted by stores or ingested and published on the selected date. Additionally, you are strongly reducing the marketing opportunities.",
              "button": {
                "cancel": "Cancel",
                "confirm": "Confirm"
              }
            },
            "release_updated": {
              "header": "Release updated!",
              "body": "Your release was successfully updated!",
              "button": {
                "close": "Close"
              }
            }
          },
      },
    },
    "transfer": {
      "title": "Transfer Release",
      "view": {
        "title": "Transfer Release",
        "label": {
          "searchBy": "Search By",
          "upc": "UPC Number",
          "url": "Store Release URL",
          "name": "Release Name",
          "spotify": "Spotify",
          "deezer": "Deezer",
          "fetchReleaseDetails": "Fetching Release Details..."
        },
        "placeholder": {
          "upc": "Enter Release UPC/EAN Number i.e. 5055964352523",
          "url": "Enter Release Store Url i.e. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn or www.deezer.com/en/album/413370367",
          "name": "Enter Release Name i.e. Warrior"
        },
        "help_text": {
          "upc": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer.",
          "url": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer.",
          "name_spotify": "Note: Only use this dropdown if you want to add a Release that is already on Spotify.",
          "name_deezer": "Note: Only use this dropdown if you want to add a Release that is already on Deezer."
        },
        "button": {
          "reset": "Reset",
          "transfer": "Transfer"
        },
        "message": {
          "release_exists": "A release with this UPC number already belongs to another user within a Music Link platform. Please import only releases which entirely belong to your company and label. If you believe that someone took your release without permission, please get in touch with our support team."
        },
      },
      "modal": {
        "header": "Release Transfer Terms",
        "ownership_warranty": {
          "header": "Ownership Warranty",
          "body": {
            "point1": "By accepting these terms, you acknowledge and guarantee that you have the lawful ownership or represent the rightful owner of all content, including the release and associated songs, provided herein.",
            "point2": "You affirm that no copyrighted material or intellectual property belonging to a third party is incorporated in this release."
          }
        },
        "non_infringement_warranty": {
          "header": "Non-Infringement Warranty",
          "body": {
            "point1": "By proceeding, you expressly confirm that the content submitted in this release does not infringe upon any third-party rights, including but not limited to copyright, trademark, or any other proprietary rights.",
            "point2": "You agree not to include any material from external sources without proper authorization."
          }
        },
        "exclusivity_declaration": {
          "header": "Exclusivity Declaration",
          "body": {
            "point1": "By consenting to these terms, you pledge that the content presented in this release is exclusive to your ownership or authorized representation, and it has not been offered or released to any other entity or platform.",
            "point2": "You take full responsibility for any breach of exclusivity and understand that any such violation may lead to legal consequences."
          }
        },
        "legal_consequences_awareness": {
          "header": "Legal Consequences Awareness",
          "body": {
            "point1": "It is crucial to comprehend that any breach of the terms and warranties outlined in this modal or terms may lead to severe legal ramifications.",
            "point2": "These penalties could include but are not limited to, substantial financial liabilities, legal injunctions, and damage to reputation.",
            "point3": "By accepting these terms, you acknowledge the seriousness of upholding the stated obligations and recognize that non-compliance may result in legal actions being pursued against you or your organization."
          }
        },
        "button": {
          "cancel": "Cancel",
          "agree": "I Agree"
        }
      },
      "form": {
        "title": "Transfer Release",
        "label": {
            "required": "Required",
            "name": "Release Name",
            "version": "Release Version",
            "subuser": "Sub-User",
            "label": "Label",
            "copyright": "Copyright ©",
            "copyright_year": "Copyright © Year",
            "copyright_publisher": "Copyright ℗",
            "copyright_publisher_year": "Copyright ℗ Year",
            "genre": "Genre",
            "subgenre": "Sub-Genre",
            "catalog_number": "Catalog Number",
            "artwork": "Artwork",
            "artwork_alt": "Your artwork",
            "new_release": "Is This A New Release?",
            "original_release_date": "Original release date",
            "official_release_date": "Official release date",
            "backcatalog": "Backcatalog",
            "assisted_dates": "Assisted Dates",
            "exclusive_store_release_date": "Exclusive store release date",
            "additional_metadata": "Additional Metadata",
            "release_description": "Release Description",
            "release_language": "Release Name Language",
            "auto_detect_language": "Auto Detect (Language)",
            "ean": "EAN / UPC",
            "territories": "Territories",
            "countries": "Countries",
            "youtube_declaration_header": "YOUTUBE CONTENT ID DECLARATION",
            "youtube_declaration_intro": "To opt-in for YouTube Content ID for this release, you must ensure you meet ALL the following requirements:",
            "youtube_declaration_certify": "I, <strong>{{firstName}} {{lastName}}</strong>, under penalty of perjury, hereby certify that the foregoing information is true and correct.",
            "youtube_declaration_point1": "I have sufficient rights to the material.",
            "youtube_declaration_point2": "All reference content is sufficiently distinctive.",
            "youtube_declaration_point3": "I have individual references for each piece of intellectual property.",
            "youtube_declaration_point4": "Content delivered is <strong>not</strong> any of the following: public domain, non-exclusively licensed content, clips from other sources used under fair use principles, video gameplay footage (by other than the game’s publisher), karaoke recordings, remaster without permission, sound-alike recordings, dubbed content, speedup/slowdown, sound effects, soundbeds, continuous DJ mixes, mashups, countdown lists or any other prohibited or ineligible content named in the YouTube’s Content ID Guidelines listed below.",
            "youtube_declaration_account": "I understand that my account may be deactivated and terminated in case of any violations. Furthermore, I fully understand that I may be liable for any fees, damages, legal expenses, or any other expenses that may accrue.",
            "youtube_declaration_guidelines": "According to <1><strong>YouTube's Content ID Guidelines</strong></1>, content submitted through this release is fully eligible for YouTube Content ID.",
            "youtube_content_id_eligible": "I confirm that my content is eligible for <strong>Youtube Content ID</strong>",
            "youtube_content_id_not_eligible": "My content is not eligible for <strong>Youtube Content ID</strong>",
            "immersive_audio": "This Release has Immersive Audio"
        },
        "placeholder": {
            "version": "Leave blank if you are not sure or if this is a regular release",
            "select_date": "Select date...",
            "copyright": "Usually your label name",
            "copyright_publisher": "Usually your label name",
            "copyright_year": "YYYY",
            "copyright_year_publisher": "YYYY",
            "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
            "label": "Select Label...",
            "subuser": "Select Sub-user...",
            "genre": "Select Genre...",
            "subgenre": "Select Sub-Genre...",
            "ean": "Leave blank if you are not sure!",
            "release_description": "A few words about your release. No links and e-mail addresses please. 600 characters max"
        },
        "help_text": {
            "name": "Please do not use release name additions such as LP and EP.",
            "version": "Some releases are released in more than one version, if so please enter the version name. If your release is original/standard release please ignore this field.",
            "subuser": "Note: Only use this dropdown if you want to add a release for any of your Sub-users otherwise leave un-selected.",
            "label": "Note: Please select your Label <strong>{{labelName}}</strong> from the dropdown if it already exists in system, otherwise create your Label <strong>{{labelName}}</strong> by clicking <5>here</5>, once it is created you can then select it from dropdown.",
            "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
            "artwork": "Upload JPG formats, resolution only 3000x3000 px, @ 72 dpi",
            "original_release_date": "Original release date for all shops worldwide.",
            "official_release_date": "Official release date for all shops worldwide.",
            "release_language": "In which language is the release name written? Please double check it if you are not sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
            "ean": "The Universal Product Code or European Article Number for the release. Valid codes are 13 digits. If you don't have your own, we will generate one for you.",
        },
        "option": {
            "yes": "Yes",
            "no": "No",
            "no_exclusive": "No exclusive",
            "beatport_2weeks": "Beatport 2 weeks",
            "beatport_4weeks": "Beatport 4 weeks",
            "preorder_1week": "Pre-order 1 week",
            "preorder_2weeks": "Pre-order 2 weeks",
            "traxsource_2weeks": "Traxsource 2 weeks",
            "select": "Select...",
            "worldwide": "Worldwide",
            "only_selected": "Only selected countries",
            "all_except_selected": "All except selected countries"
        },
        "message": {
            "track_name_required": "Please type track name",
            "mix_name_required": "Please type mix name",
            "mix_name_invalid": "The mix name can only consist of alphabetical, number, space and underscore",
            "artist_required": "Please select artist",
            "artist_type_required": "Please select artist type",
            "catalog_duplicate": "Catalog number '{{number}}' was used. Please insert another one.",
            "artist_added": "New Artist has been added!",
            "track_limit": "Your current track limit is {{trackLimit}} track(s). In order to upload more tracks please upgrade your account or contact our support team.",
            "select_day": "Please select a day.",
            "form_error": "Form cannot be submitted! Please fill all fields and check errors!",
            "ean_invalid": "The value is not valid EAN. If you are inserting a new release, leave this field blank and we will generate EAN for you. If you are uploading a back catalog and EAN is not valid, please contact us.",
            "ean_length": "The EAN number must be equal to 13 characters",
            "artwork_invalid": "This file is invalid, please make sure the image has .jpg extension, RGB Colours, 3000 X 3000 dimensions and up to 4MB.",
            "track_invalid": "This file is invalid, please make sure to properly encode your file in 16 bit, 44.1 Khz.",
        },
        "button": {
            "reset": "Reset",
            "save_only": "Save only",
            "save_and_continue": "Save and continue"
        },
        "modal": {
          "assisted_days": {
            "header": "Are you sure you want to ignore release date best practices?",
            "body": "Please note by selecting this option, your release date might not be accepted by stores or ingested and published on the selected date. Additionally, you are strongly reducing the marketing opportunities.",
            "button": {
              "cancel": "Cancel",
              "confirm": "Confirm"
            }
          },
          "release_created": {
            "header": "Release created!",
            "body": "Your release was successfully created!",
            "button": {
              "close": "Close"
            }
          },
          "release_transfer_declaration": {
            "header": "Transfer Release Declaration",
            "body": "I have checked and completed all of the needed information for this release and it is now ready for UPLOAD.",
            "button": {
              "cancel": "Cancel",
              "confirm": "Confirm"
            }
          }
        },  
      },
    },
    "viewDetails": {
      "title": "View Release",
      "form": {
        "label": {
            "required": "Required",
            "name": "Release Name",
            "version": "Release Version",
            "subuser": "Sub-User",
            "label": "Label",
            "copyright": "Copyright ©",
            "copyright_year": "Copyright © Year",
            "copyright_publisher": "Copyright ℗",
            "copyright_publisher_year": "Copyright ℗ Year",
            "genre": "Genre",
            "subgenre": "Sub-Genre",
            "catalog_number": "Catalog Number",
            "artwork": "Artwork",
            "artwork_alt": "Your artwork",
            "new_release": "Is This A New Release?",
            "original_release_date": "Original release date",
            "official_release_date": "Official release date",
            "backcatalog": "Backcatalog",
            "assisted_dates": "Assisted Dates",
            "exclusive_store_release_date": "Exclusive store release date",
            "additional_metadata": "Additional Metadata",
            "release_description": "Release Description",
            "release_language": "Release Name Language",
            "auto_detect_language": "Auto Detect (Language)",
            "ean": "EAN / UPC",
            "auto_generate_ean": "Auto generate (ean)",
            "territories": "Territories",
            "countries": "Countries",
            "youtube_declaration_header": "YOUTUBE CONTENT ID DECLARATION",
            "youtube_declaration_intro": "To opt-in for YouTube Content ID for this release, you must ensure you meet ALL the following requirements:",
            "youtube_declaration_certify": "I, <strong>{{firstName}} {{lastName}}</strong>, under penalty of perjury, hereby certify that the foregoing information is true and correct.",
            "youtube_declaration_point1": "I have sufficient rights to the material.",
            "youtube_declaration_point2": "All reference content is sufficiently distinctive.",
            "youtube_declaration_point3": "I have individual references for each piece of intellectual property.",
            "youtube_declaration_point4": "Content delivered is <strong>not</strong> any of the following: public domain, non-exclusively licensed content, clips from other sources used under fair use principles, video gameplay footage (by other than the game’s publisher), karaoke recordings, remaster without permission, sound-alike recordings, dubbed content, speedup/slowdown, sound effects, soundbeds, continuous DJ mixes, mashups, countdown lists or any other prohibited or ineligible content named in the YouTube’s Content ID Guidelines listed below.",
            "youtube_declaration_account": "I understand that my account may be deactivated and terminated in case of any violations. Furthermore, I fully understand that I may be liable for any fees, damages, legal expenses, or any other expenses that may accrue.",
            "youtube_declaration_guidelines": "According to <1><strong>YouTube's Content ID Guidelines</strong></1>, content submitted through this release is fully eligible for YouTube Content ID.",
            "youtube_content_id_eligible": "I confirm that my content is eligible for <strong>Youtube Content ID</strong>",
            "youtube_content_id_not_eligible": "My content is not eligible for <strong>Youtube Content ID</strong>",
            "immersive_audio": "This Release has Immersive Audio"
        },
        "placeholder": {
            "version": "Leave blank if you are not sure or if this is a regular release",
            "select_date": "Select date...",
            "copyright": "Usually your label name",
            "copyright_publisher": "Usually your label name",
            "copyright_year": "YYYY",
            "copyright_year_publisher": "YYYY",
            "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
            "label": "Select Label...",
            "subuser": "Select Sub-user...",
            "artist": "Select Artist...",
            "genre": "Select Genre...",
            "subgenre": "Select Sub-Genre...",
            "ean": "Leave blank if you are not sure!",
            "release_description": "A few words about your release. No links and e-mail addresses please. 600 characters max"
        },
        "help_text": {
            "name": "Please do not use release name additions such as LP and EP.",
            "version": "Some releases are released in more than one version, if so please enter the version name. If your release is original/standard release please ignore this field.",
            "subuser": "Note: Only use this dropdown if you want to add a release for any of your Sub-users otherwise leave un-selected.",
            "catalog_number": "Insert your catalog number. Usually labels insert label name abbreviation and a number. I.e {{prefix}}001, {{prefix}}002...",
            "artwork": "Upload JPG formats, resolution only 3000x3000 px, @ 72 dpi",
            "original_release_date": "Original release date for all shops worldwide.",
            "official_release_date": "Official release date for all shops worldwide.",
            "release_language": "In which language is the release name written? Please double check it if you are not sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
            "ean": "The Universal Product Code or European Article Number for the release. Valid codes are 13 digits. If you don't have your own, we will generate one for you.",
        },
        "option": {
            "yes": "Yes",
            "no": "No",
            "no_exclusive": "No exclusive",
            "beatport_2weeks": "Beatport 2 weeks",
            "beatport_4weeks": "Beatport 4 weeks",
            "preorder_1week": "Pre-order 1 week",
            "preorder_2weeks": "Pre-order 2 weeks",
            "traxsource_2weeks": "Traxsource 2 weeks",
            "select": "Select...",
            "worldwide": "Worldwide",
            "only_selected": "Only selected countries",
            "all_except_selected": "All except selected countries"
        },
        "message": {
            "track_name_required": "Please type track name",
            "mix_name_required": "Please type mix name",
            "mix_name_invalid": "The mix name can only consist of alphabetical, number, space and underscore",
            "artist_required": "Please select artist",
            "artist_type_required": "Please select artist type",
            "catalog_duplicate": "Catalog number '{{number}}' was used. Please insert another one.",
            "artist_added": "New Artist has been added!",
            "track_limit": "Your current track limit is {{trackLimit}} track(s). In order to upload more tracks please upgrade your account or contact our support team.",
            "select_day": "Please select a day.",
            "form_error": "Form cannot be submitted! Please fill all fields and check errors!",
            "ean_invalid": "The value is not valid EAN. If you are inserting a new release, leave this field blank and we will generate EAN for you. If you are uploading a back catalog and EAN is not valid, please contact us.",
            "ean_length": "The EAN number must be equal to 13 characters",
            "artwork_invalid": "This file is invalid, please make sure the image has .jpg extension, RGB Colours, 3000 X 3000 dimensions and up to 4MB.",
            "track_invalid": "This file is invalid, please make sure to properly encode your file in 16 bit, 44.1 Khz.",
        },
        "button": {
          "submit": "Submit Form"
        },
        "modal": {
          "assisted_days": {
            "header": "Are you sure you want to ignore release date best practices?",
            "body": "Please note by selecting this option, your release date might not be accepted by stores or ingested and published on the selected date. Additionally, you are strongly reducing the marketing opportunities.",
            "button": {
              "cancel": "Cancel",
              "confirm": "Confirm"
            }
          },
          "release_updated": {
            "header": "Release updated!",
            "body": "Your release was successfully updated!",
            "button": {
              "close": "Close"
            }
          }
        },
    },
    },
    "artists_row": {
      "artistType": {
        "main": "Main Artist",
        "featuring": "Featuring Artist",
        "remixer": "Remixer"
      },
      "placeholder": {
        "selectArtist": "Select Artist..."
      },
      "button": {
        "remove": "Remove",
        "addAnother": "Add another",
        "createNew": "Create new?"
      },
      "modal": {
        "header": "Are you sure you want to assign this artist as a Featuring Artist?",
        "body": "Please do not confuse Featuring Artist with a Remixer. Featuring Artist should only be added if you are confident and sure that this artist is not the Main Artist or Remixer.",
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "label": {
        "order": "Order",
        "artistName": "Artist name",
        "artistType": "Artist type",
        "artists": "Artists",
        "required": "Required"
      },
      "help_text": {
        "artists": "If the release is written by more than <strong>4 Main Artists</strong> please use <strong>Various Artists</strong>. Track artists, remixers and contributors should be added in Track Edit step."
      }
    },
    "tracks_row": {
      "label": {
        "tracks": "Tracks",
        "order": "Order",
        "trackName": "Track name",
        "mixName": "Mix name",
        "file": "File",
        "albumOnly": "Only Album",
        "required": "Required",
        "stereo": "Stereo",
        "dolbyAtmos": "Dolby Atmos",
        "addAnother": "Add another",
        "remove": "Remove?",
        "onlyAlbum": "Only Album",
        "mixTypes": {
          "originalMix": "Original Mix",
          "remixOrMix": "This is a Remix or Mix"
        },
      },
      "button": {
        "remove": "Remove",
        "addAnother": "Add another"
      },
      "validation": {
        "trackName": "Please type track name",
        "mixName": "Please type mix name",
        "mixNameRegex": "The mix name can only consist of alphabetical, number, space and underscore",
        "trackFile": "Please select track file",
        "trackFileDolby": "Please select track dolby atmos file",
        "trackFileDuration": "Duration of Stereo and Dolby track files must match",
        "swapTrackAudioTokenRequiredTooltip": "Your current token balance is insufficient. At least 1 token is required to swap track audio."
      }
    },
    "transfer_artists_row": {
      "label": {
        "artists": "Artists",
        "order": "Order",
        "artistName": "Artist name",
        "artistType": "Artist type",
        "required": "Required"
      },
      "placeholder": {
        "selectArtist": "Select Artist..."
      },
      "help_text": {
        "artists": "If the release is written by more than <strong>4 Main Artists</strong> please use <strong>Various Artists</strong>. Track artists, remixers and contributors should be added in Track Edit step."
      },
      "option": {
        "artistType": {
          "main": "Main Artist",
          "featuring": "Featuring Artist",
          "remixer": "Remixer"
        },
      },
      "button": {
        "remove": "Remove",
        "addAnother": "Add another",
        "createNew": "Create new?"
      },
      "message": {
        "errorArtistRequired": "Please select artist",
        "errorArtistTypeRequired": "Please select type of artist"
      },
      "modal": {
        "header": "Are you sure you want to assign this artist as a Featuring Artist?",
        "body": "Please do not confuse Featuring Artist with a Remixer. Featuring Artist should only be added if you are confident and sure that this artist is not the Main Artist or Remixer.",
        "button": {
          "cancel": "Cancel",
          "confirm": "Confirm"
        }
      },
    },
    "store_picker": {
      "label": {
        "stores": "Stores"
      },
      "placeholder": {
        "search": "Search store..."
      },
      "section": {
        "mandatory": "Mandatory",
        "optional": "Optional",
        "optional_locked": "Optional Additional Stores",
        "summary": {
          "read_only": "{{title}} ({{count}} total)",
          "editable": "{{title}} ({{total}} total, {{selected}} selected)"
        }
      },
      "message": {
        "no_stores": "No stores found.",
        "availability": "Beatport is only available for Dance releases with Beatport-approved labels. Traxsource is only available for Dance releases with Traxsource-approved labels.",
        "youtube_declaration": "Please sign the YouTube Content ID Declaration first.",
        "youtube_ineligible": "This store is ineligible as you've stated that you don't have the ownership rights. If claimed falsely, you could be liable for a legal dispute.",
        "youtube_content_id": "This store is not applicable for YouTube Content ID eligible releases because it is delivered to both Youtube Content ID and Youtube Premium.",
        "beatport": "Beatport can be selected only when the Genre is Dance and the label is approved for Beatport.",
        "traxsource": "Traxsource can be selected only when the Genre is Dance and the label is approved for Traxsource.",
        "juno": "JunoDownload can be selected only when the Genre is Dance.",
        "contact_support": "Please contact our support team to unlock those stores.",
        "optional_additional_none_selected": "You haven't selected any Optional Additional Stores. These can expand your reach, Are you sure you want to skip them?",
        "optional_paid_insufficient_tokens": "Insufficient token balance. At least 1 token is required to select Optional Additional Stores.",
        "optional_paid_insufficient_tokens_with_link": "Your current token balance is insufficient. At least 1 token is required to select Optional Additional Stores. <2>Order tokens</2> to continue."
      }
    },
    "transfer_tracks_row": {
      "label": {
        "tracks": "Tracks",
        "order": "Order",
        "trackName": "Track name",
        "mixName": "Mix name",
        "file": "File",
        "albumOnly": "Only Album",
        "required": "Required",
        "stereo": "Stereo",
        "dolbyAtmos": "Dolby Atmos",
        "addAnother": "Add another",
        "remove": "Remove?",
        "onlyAlbum": "Only Album",
        "mixTypes": {
          "originalMix": "Original Mix",
          "remixOrMix": "This is a Remix or Mix"
        },
      },
      "button": {
        "remove": "Remove",
        "addAnother": "Add another"
      },
      "validation": {
        "trackName": "Please type track name",
        "mixName": "Please type mix name",
        "mixNameRegex": "The mix name can only consist of alphabetical, number, space and underscore",
        "trackFile": "Please select track file",
        "trackFileDolby": "Please select track dolby atmos file",
        "trackFileDuration": "Duration of Stereo and Dolby track files must match"
      }
    },
};

export default releasesEN;